module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-dropdown__container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleThisDropdown.apply(null, arguments)
      }
    }
  }, [_c('button', {
    staticClass: "a-button a-button--header-button",
    class: {
      'a-button--dropdown': _vm.isADropdown, 'a-button--no-bottom-radius': _vm.isThisDropdownOpen
    }
  }, [_vm._v(_vm._s(_vm.buttonName) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-dropdown",
    class: [_vm.dropdownName, {
      'm-dropdown--show': _vm.isThisDropdownOpen
    }]
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2249193d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dropdown/Dropdown.vue
// module id = 1608
// module chunks = 0